import { FC } from 'react';

import NavigationOverlay from './NavigationOverlay';
import { useProgressDispatchContext } from '../contexts/ProgressContext';

export const ImageNavigationOverlay: FC = () => {
    const dispatch = useProgressDispatchContext();
    return (
        <NavigationOverlay
            onPlay={() => dispatch({ type: 'RESUME' })}
            onPause={() => dispatch({ type: 'PAUSE' })}
        />
    );
};
